import { StyledAudioQuestionModal } from './AudioQuestionModal.styled';
import { Button, Radio, Space } from 'antd';
import { useContext, useRef } from 'react';
import useAudioQuestion from './useAudioQuestion.hook';
import { AudioAutoPlayerContext } from '@/shared/Players/AudioAutoPlayer/AudioAutoPlayerContext';
import TextWithAudio from '@/shared/TextWithAudio/TextWithAudio';

export default function AudioQuestionModal({
  question,
  questionsProgress,
  questionActions,
}) {
  const modalRef = useRef();
  const audioAutoPlayerContext = useContext(AudioAutoPlayerContext);
  const audioState = audioAutoPlayerContext.state;
  const { state, actions } = useAudioQuestion({
    question,
    onAnswer: questionActions.onAnswer,
    audioAutoPlayerContext,
    modalRef,
  });

  return (
    <StyledAudioQuestionModal ref={modalRef} modalWidth={state.modalWidth}>
      <div className="question-dialog">
        <div className="question-title">
          <TextWithAudio
            text={state.questionTitle?.text}
            playing={state.questionTitle?.playing}
          />
        </div>
        <Radio.Group
          className={`question-options${state.answer ? ' answered' : ''}`}
        >
          <Space direction="vertical" onChange={actions.onOptionSelect}>
            {state.options &&
              state.options.map((option, index) => {
                return (
                  <Radio
                    value={index}
                    key={index}
                    className={`option${
                      state.answer
                        ? state.answer.selected == option.text
                          ? ` selected${state.answer.correct ? ' correct' : ''}`
                          : option.correct
                          ? ' correct'
                          : ''
                        : ''
                    }`}
                    disabled={audioState.playing || state.answer}
                  >
                    <TextWithAudio
                      className="option-text"
                      text={option.text}
                      playing={option.playing}
                    />
                  </Radio>
                );
              })}
          </Space>
        </Radio.Group>
        <div className="feedback">
          <div className="progress">{questionsProgress}</div>
          {state.answer && (
            <Button type="primary" onClick={questionActions.onContinue}>
              Continue
            </Button>
          )}
        </div>
      </div>
    </StyledAudioQuestionModal>
  );
}
